/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CountryLangViewModel } from "../types/CountryLangViewModel.ts";

export const countryLangViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  countryId: z.optional(z.number().int()),
  countryName: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  cultureDisplayName: z.string().nullish(),
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<CountryLangViewModel>;
